import React from 'react'
import clsx from 'clsx'
import { toStructureLogoSrc } from '../../shared/competitionUrls'
import style from './style.module.scss'
import {LogoOrGeneric} from '../LogoOrGeneric'

interface DisplayEquipeProps {
    libelle: string
    displayLogo: boolean
    logo: string
    size?: 'medium' | 'small' | 'large'
}

export const DisplayEquipe = ({
    libelle,
    displayLogo,
    logo,
    size = 'large',
}: DisplayEquipeProps) => {
    const logoUrl = displayLogo
        ? logo.startsWith('/')
            ? logo
            : toStructureLogoSrc(logo, 64)
        : undefined
    return (
        <div className={style.cell}>
            <LogoOrGeneric
                className={clsx(style.logo, style[size])}
                imageUrl={logoUrl}
                title={libelle}
            />
            <span className={clsx(style.equipeName, style[size])}>{libelle}</span>
        </div>
    )
}
